import { render, staticRenderFns } from "./getLocationHygienist.vue?vue&type=template&id=f6776560&scoped=true"
import script from "./getLocationHygienist.vue?vue&type=script&lang=js"
export * from "./getLocationHygienist.vue?vue&type=script&lang=js"
import style0 from "./getLocationHygienist.vue?vue&type=style&index=0&id=f6776560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6776560",
  null
  
)

export default component.exports